import React, { useState } from 'react';
import styled from 'styled-components';
import { BorderColor, TextColor, PrimaryColor } from 'styles/Global/colorSemantic';
import CreateVoucherModal from 'components/Modal/CreateVoucherModal';

interface AdminVoucherFilterProps {
    onFilterChange: (status: number | null, type: number | null) => void;
    onReset: () => void;
    onCreateVoucher?: (type: number, count: number) => void;
}

const AdminVoucherFilter: React.FC<AdminVoucherFilterProps> = ({ onFilterChange, onReset, onCreateVoucher }) => {
    const [selectedStatus, setSelectedStatus] = useState<number | null>(null);
    const [selectedType, setSelectedType] = useState<number | null>(null);
    const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState<boolean>(false);
    const [isTypeDropdownOpen, setIsTypeDropdownOpen] = useState<boolean>(false);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);

    const statusOptions = [
        { value: null, label: '전체' },
        { value: 0, label: '미사용' },
        { value: 1, label: '사용' },
        { value: 2, label: '만료' },
    ];

    const typeOptions = [
        { value: null, label: '전체' },
        { value: 0, label: '성남시' },
        { value: 1, label: 'TLC 상담' },
        { value: 2, label: '테스트' },
        { value: 3, label: '컨시어지' },
        { value: 4, label: '마인드업AI' },
    ];

    const handleStatusChange = (status: number | null) => {
        setSelectedStatus(status);
        setIsStatusDropdownOpen(false);
        onFilterChange(status, selectedType);
    };

    const handleTypeChange = (type: number | null) => {
        setSelectedType(type);
        setIsTypeDropdownOpen(false);
        onFilterChange(selectedStatus, type);
    };

    const handleReset = () => {
        setSelectedStatus(null);
        setSelectedType(null);
        onReset();
    };

    const handleCreateVoucher = (type: number, count: number) => {
        if (onCreateVoucher) {
            onCreateVoucher(type, count);
        }
    };

    return (
        <>
            <FilterContainer>
                <FilterGroup>
                    <FilterLabel>상태</FilterLabel>
                    <DropdownContainer>
                        <DropdownButton onClick={() => setIsStatusDropdownOpen(!isStatusDropdownOpen)}>
                            {statusOptions.find(option => option.value === selectedStatus)?.label || '전체'}
                        </DropdownButton>
                        {isStatusDropdownOpen && (
                            <DropdownList>
                                {statusOptions.map((option) => (
                                    <DropdownItem 
                                        key={option.value === null ? 'all' : option.value}
                                        onClick={() => handleStatusChange(option.value)}
                                    >
                                        {option.label}
                                    </DropdownItem>
                                ))}
                            </DropdownList>
                        )}
                    </DropdownContainer>
                </FilterGroup>

                <FilterGroup>
                    <FilterLabel>타입</FilterLabel>
                    <DropdownContainer>
                        <DropdownButton onClick={() => setIsTypeDropdownOpen(!isTypeDropdownOpen)}>
                            {typeOptions.find(option => option.value === selectedType)?.label || '전체'}
                        </DropdownButton>
                        {isTypeDropdownOpen && (
                            <DropdownList>
                                {typeOptions.map((option) => (
                                    <DropdownItem 
                                        key={option.value === null ? 'all' : option.value}
                                        onClick={() => handleTypeChange(option.value)}
                                    >
                                        {option.label}
                                    </DropdownItem>
                                ))}
                            </DropdownList>
                        )}
                    </DropdownContainer>
                </FilterGroup>

                <ResetButton onClick={handleReset}>초기화</ResetButton>
                <CreateButton onClick={() => setIsCreateModalOpen(true)}>생성</CreateButton>
            </FilterContainer>
            
            <CreateVoucherModal
                isOpen={isCreateModalOpen}
                onClose={() => setIsCreateModalOpen(false)}
                onCreateVoucher={handleCreateVoucher}
            />
        </>
    );
};

const FilterContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
`;

const FilterGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const FilterLabel = styled.span`
    font-size: 14px;
    color: ${TextColor.color_text_normal};
`;

const DropdownContainer = styled.div`
    position: relative;
`;

const DropdownButton = styled.button`
    padding: 8px 12px;
    border: 1px solid ${BorderColor.color_border_neutral};
    border-radius: 4px;
    background-color: white;
    cursor: pointer;
    min-width: 120px;
    text-align: left;
`;

const DropdownList = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: white;
    border: 1px solid ${BorderColor.color_border_neutral};
    border-radius: 4px;
    margin-top: 4px;
    z-index: 10;
`;

const DropdownItem = styled.div`
    padding: 8px 12px;
    cursor: pointer;
    
    &:hover {
        background-color: #f5f5f5;
    }
`;

const ResetButton = styled.button`
    padding: 8px 16px;
    border: 1px solid ${BorderColor.color_border_neutral};
    border-radius: 4px;
    background-color: white;
    cursor: pointer;
    margin-left: auto;
`;

const CreateButton = styled.button`
    padding: 8px 16px;
    border: 1px solid ${BorderColor.color_border_neutral};
    border-radius: 4px;
    background-color: white;
    cursor: pointer;
    margin-left: 8px;
`;

export default AdminVoucherFilter; 